import {
    FlashScreenBackgroundStyled,
    FlashScreenCloseButtonStyled,
    FlashScreenContentStyled,
    FlashScreenImageWrapperStyled,
    FlashScreenStyled
} from "./styled/FlashScreenStyled";
import BinIcon from "../icon/Icon";
import styled from 'styled-components';
import { ReactNode } from 'react';

interface IFlashScreenProps {
    children: ReactNode,
    className?: string,
    contentClassName?: string,
    contentBackground?: string,
    handleClose?: () => void,
    image?: string,
}

function FlashScreen(props:IFlashScreenProps) {
    const {
        children,
        className,
        contentBackground = '#2744AA',
        contentClassName,
        handleClose,
        image,
    } = props;

    return <FlashScreenStyled className={className}>
        {
            !!handleClose && <FlashScreenCloseButtonStyled onClick={handleClose}>
                <BinIcon name={'IcClose'}/>
            </FlashScreenCloseButtonStyled>
        }
        <FlashScreenContentStyled className={contentClassName}>
            <FlashScreenBackgroundStyled background={contentBackground}/>
            {
                !!image && <FlashScreenImageWrapperStyled>
                    <img src={image} alt=""/>
                </FlashScreenImageWrapperStyled>
            }
            {children}
        </FlashScreenContentStyled>
    </FlashScreenStyled>
}

export const FlashScreenDesktop = styled(FlashScreen)`
    position: static;
    padding: 64px;
    
    ${FlashScreenContentStyled} {
        max-width: unset;
    }
`;

export default FlashScreen;
